import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { SelectModule } from 'ng2-select';

import { MdModule } from '../md/md.module';
import { MaterialModule } from '../app.module';

import { HdcheckerComponent } from './hdchecker.component';
import { HdcheckerRoutes } from './hdchecker.routing';
import { LinktomasterComponent } from './linktomaster/linktomaster.component';
import { PhysicaldestructionComponent } from './physicaldestruction/physicaldestruction.component';
import { SearchforhddlinktomasterComponent } from './searchforhddlinktomaster/searchforhddlinktomaster.component';
import { ComponentsModule } from '../shared/components/components.module';
import { ManualityaddComponent } from './manualityadd/manualityadd.component';
import { ModulosModule } from "../modulos/modulos.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(HdcheckerRoutes),
        FormsModule,
        NouisliderModule,
        MdModule,
        TagInputModule,
        MaterialModule,
        ReactiveFormsModule,
        ComponentsModule,
        ModulosModule
    ],
     exports: [],
    declarations: [HdcheckerComponent, LinktomasterComponent, PhysicaldestructionComponent, SearchforhddlinktomasterComponent, ManualityaddComponent],
    entryComponents: [ ManualityaddComponent ]
})

export class HdcheckerModule {}
